import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["action"]
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["aria-expanded", "aria-label"]
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = ["aria-selected"]
const _hoisted_7 = ["aria-selected", "onClick", "data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_click_outside = _resolveComponent("click-outside")
  const _component_change_display_currency_modal = _resolveComponent("change-display-currency-modal")

  return (_ctx.isCurrencySelectorVisible)
    ? (_openBlock(), _createElementBlock("form", {
        key: 0,
        ref: "form",
        action: _ctx.changeCurrencyUrl,
        method: "post",
        class: "gfu-currency-selector",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
      }, [
        (_ctx.isV1)
          ? (_openBlock(), _createElementBlock("input", {
              key: 0,
              type: "hidden",
              name: "returnUrl",
              value: _ctx.currentActionUrl
            }, null, 8 /* PROPS */, _hoisted_2))
          : _createCommentVNode("v-if", true),
        (_ctx.isV1)
          ? (_openBlock(), _createElementBlock("input", {
              key: 1,
              type: "hidden",
              name: "projectCurrencyID",
              value: _ctx.pendingProjectCurrencyId
            }, null, 8 /* PROPS */, _hoisted_3))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_click_outside, { call: $options.closeDropdown }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers((...args) => ($options.closeDropdown && $options.closeDropdown(...args)), ["prevent"]), ["esc"]))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(['gfu-currency-selector__select', {'is-expanded': _ctx.isDropdownExpanded}])
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "gfu-currency-selector__label",
                  "aria-expanded": _ctx.isDropdownExpanded,
                  "aria-label": _ctx.isUsingProjectCurrencies ? _ctx.useProjectCurrenciesLabel : null,
                  "aria-haspopup": "listbox",
                  onClick: _cache[0] || (_cache[0] = (...args) => ($options.toggleDropdown && $options.toggleDropdown(...args))),
                  "data-qa": "display-currency-selector:SelectedCurrency"
                }, [
                  (_ctx.isUsingProjectCurrencies)
                    ? (_openBlock(), _createBlock(_component_base_icon, {
                        key: 0,
                        name: "money-bill-transfer",
                        "aria-hidden": "true",
                        "data-qa": "display-currency-selector:ProjectCurrency"
                      }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.selectedCurrencyLabel), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */)),
                  _createVNode(_component_base_icon, {
                    name: "chevron-down",
                    class: "_tc--accent",
                    "aria-hidden": "true"
                  })
                ], 8 /* PROPS */, _hoisted_4)
              ], 2 /* CLASS */),
              _createVNode(_Transition, { name: "gfu-fade" }, {
                default: _withCtx(() => [
                  (_ctx.isDropdownExpanded)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "gfu-currency-selector__dropdown",
                        role: "listbox",
                        "aria-label": _ctx.Resources.ProjectHome.DisplayCurrenciesLabel,
                        "data-qa": "display-currency-selector:CurrenciesList"
                      }, [
                        (!_ctx.isV1)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: _normalizeClass(['gfu-currency-selector-option', {'is-selected': _ctx.isProjectCurrenciesOptionSelected}]),
                              role: "option",
                              "aria-selected": _ctx.isProjectCurrenciesOptionSelected,
                              onClick: _cache[1] || (_cache[1] = (...args) => ($options.handleProjectCurrencySelection && $options.handleProjectCurrencySelection(...args))),
                              "data-qa": "display-currency-selector:UseProjectCurrencies"
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.useProjectCurrenciesLabel) + " ", 1 /* TEXT */),
                              (_ctx.isProjectCurrenciesOptionSelected)
                                ? (_openBlock(), _createBlock(_component_base_icon, {
                                    key: 0,
                                    name: "check",
                                    class: "_tc--accent",
                                    "aria-hidden": "true"
                                  }))
                                : _createCommentVNode("v-if", true)
                            ], 10 /* CLASS, PROPS */, _hoisted_6))
                          : _createCommentVNode("v-if", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currencyOptions, (currency) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: currency.currencyID,
                            type: "button",
                            class: _normalizeClass(['gfu-currency-selector-option', {'is-selected': currency.isSelected}]),
                            role: "option",
                            "aria-selected": currency.isSelected,
                            onClick: $event => ($options.selectDisplayCurrency(currency.currencyID)),
                            "data-qa": `display-currency-selector:${currency.currencyID}`
                          }, [
                            _createTextVNode(_toDisplayString(currency.name) + " - " + _toDisplayString(currency.shortName) + " (" + _toDisplayString(currency.symbol) + ") ", 1 /* TEXT */),
                            (currency.isSelected)
                              ? (_openBlock(), _createBlock(_component_base_icon, {
                                  key: 0,
                                  name: "check",
                                  class: "_tc--accent",
                                  "aria-hidden": "true"
                                }))
                              : _createCommentVNode("v-if", true)
                          ], 10 /* CLASS, PROPS */, _hoisted_7))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 8 /* PROPS */, _hoisted_5))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              })
            ], 32 /* NEED_HYDRATION */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["call"]),
        (!_ctx.isV1)
          ? (_openBlock(), _createBlock(_component_change_display_currency_modal, {
              key: 2,
              "is-visible": _ctx.isCurrencyModalVisible,
              currency: _ctx.pendingCurrency,
              onAccept: $setup.applyCurrency,
              onCancel: _ctx.cancelCurrency
            }, null, 8 /* PROPS */, ["is-visible", "currency", "onAccept", "onCancel"]))
          : _createCommentVNode("v-if", true)
      ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}